<template>
  <page-view :key="$route.hash" class="subpage" :title="$t('commerce.title')" backLink="/dashboard" backText="Back to dashboard">
    <template slot="tabs">
      <page-tab @click="handleLink($event, '/commerce')" link="/commerce" :active="currentTab == ''" icon="accounting-24">{{ $t('commerce.transactions') }}</page-tab>
      <page-tab @click="handleLink($event, '/commerce/reports')" link="/commerce/reports" :active="currentTab == 'reports'" icon="report-24">{{ $t('commerce.reports') }}</page-tab>
      <page-tab @click="handleLink($event, '/commerce/payouts')" link="/commerce/payouts" :active="currentTab == 'payouts'" icon="arrows-flowright-24">{{ $t('commerce.payouts') }}</page-tab>
      <page-tab @click="handleLink($event, '/commerce/donations')" link="/commerce/donations" :active="currentTab == 'donations'" icon="heart-24">{{ $t('donations.donations') }}</page-tab>
    </template>
    <router-view />
  </page-view>
</template>

<script>
export default {
  computed: {
    /**
     * Return the current tab
     * @return {String}
     */
    currentTab() {
      const tab = this.$route.path.split('/').pop();
      return tab === 'commerce' ? '' : tab;
    },
  },
};
</script>
